module.exports = __webpack_public_path__ + "img/img3.57504eaf.57504eaf.jpg";